import React, { useEffect } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { useBreadcrumbs } from "../../contexts/BreadcrumbsContext";
import Users from "./users/Users";
import Roles from "./roles/Roles";

const SettingsPage = () => {
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Settings", href: "/settings/users" }
    ]);
  }, [setBreadcrumbs]);

  return (
    <div className="p-4">
      <Tabs defaultValue="users">
        <TabsList className="mb-4">
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="roles">Roles</TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <Users />
        </TabsContent>

        <TabsContent value="roles">
          <Roles />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsPage;
